import { FiservCardStatusEnum } from '@common-fe/common-fe';

import { Roles } from '@/common/constants';
import { ReplacementInitiationType } from '@/modules/transaction/Cards/Cards.types';
import { baseStoreCreator } from '@/utils/store';

export interface UserVerificationStatus {
  employeeId?: string;
  roleType?: Roles;
  fullName?: string;
  isWelcomeEmailSent?: boolean;
  cardLast2?: string;
  cardLast4?: string;
  cardStatus?: FiservCardStatusEnum;
  cardMailedOn?: string;
  cardCreatedAt?: string;
  replacementInitiation?: ReplacementInitiationType;
}

export const DEFAULT_VALUES: UserVerificationStatus = {
  employeeId: undefined,
  roleType: undefined,
  fullName: undefined,
  isWelcomeEmailSent: undefined,
  cardLast2: undefined,
  cardLast4: undefined,
  cardStatus: undefined,
  cardMailedOn: undefined,
  cardCreatedAt: undefined,
  replacementInitiation: undefined,
};

export const useStore = baseStoreCreator<UserVerificationStatus>(DEFAULT_VALUES);

export default useStore;
